// @flow

import React from "react";

type Props = {
  size?: number
};

const DefaultCheckbox = ({ size = 24 }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={`${size}px`}
    height={`${size}px`}
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      fill="#e2e8f0"
      d="M19 5v14H5V5h14zm0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
    />
  </svg>
);

export default DefaultCheckbox;
